import React, { useState } from "react";
import styled from "styled-components";
import colors from '../styles/colors';
import { IconEnum as Icons } from './Icons';
import Icon from './Icon';
import ReactTooltip from "react-tooltip";
import SidebarContent from "./HelpSidebarContent";

const HelpButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 16px 16px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  &:hover {
    background-color: #0056b3;
  }
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 340px;
  height: 100%;
  background-color: #fff;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: ${(props) => (props.isOpen ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
  padding: 20px;
  overflow-y: auto;
  z-index: 999;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  &:hover {
    color: #007bff;
  }
`;
const HelpSidebar = ({ isOpen, closeSidebar , sidebarType }) => {
  
  return (
    <>
    <Sidebar isOpen={isOpen}>
      <CloseButton onClick={closeSidebar}>×</CloseButton>
      <SidebarContent  sidebarType={sidebarType}/>
    </Sidebar>

    <ReactTooltip place="right" type="light" effect="solid" />
  </>  );
};

export default HelpSidebar;
